module.exports = __webpack_public_path__ + "static/link-avoidclickhere-dont-41b6acdbda10c3d4ca16dae71de336c6.png";